import IntegrationCallStateOverviewResourceListResultModel from '../../generated/types/model/resource/IntegrationCallStateOverviewResourceListResultModel';

export default class IntegrationCallStateOverviewResourceListResultViewModel extends IntegrationCallStateOverviewResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
